export const FISCAL_YEAR_STORAGE_KEY = 'care-kathmandu-fiscal-year';

export function getCurrentFiscalYearStart(date = new Date()): number {
    const year = date.getFullYear();
    const isOnOrAfterJuly16 = date.getMonth() > 6 || (date.getMonth() === 6 && date.getDate() >= 16);
    return isOnOrAfterJuly16 ? year : year - 1;
}

export function formatFiscalYear(startYear: number): string {
    return `FY ${startYear}/${String(startYear + 1).slice(-2)}`;
}

export function formatFiscalYearRange(startYear: number): string {
    return `July 16, ${startYear} – July 15, ${startYear + 1}`;
}

export function isDateInFiscalYear(value: string | Date, startYear: number): boolean {
    const date = value instanceof Date ? value : new Date(value);
    const start = new Date(Date.UTC(startYear, 6, 16));
    const end = new Date(Date.UTC(startYear + 1, 6, 16));
    return date >= start && date < end;
}
